"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var FormatQuote_exports = {};
__export(FormatQuote_exports, {
  default: () => FormatQuote_default
});
module.exports = __toCommonJS(FormatQuote_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6.75 14.4102C6.6849 14.4102 6.61979 14.4036 6.55469 14.3906C6.5026 14.3776 6.45052 14.3581 6.39844 14.332C6.21615 14.2409 6.08594 14.0977 6.00781 13.9023C5.94271 13.694 5.96224 13.4922 6.06641 13.2969L7.16016 11.0898H6.33984C5.87109 11.0898 5.47396 10.9271 5.14844 10.6016C4.82292 10.276 4.66016 9.87891 4.66016 9.41016V7.75C4.66016 7.29427 4.82292 6.90365 5.14844 6.57812C5.47396 6.2526 5.87109 6.08984 6.33984 6.08984H8C8.45573 6.08984 8.84635 6.2526 9.17188 6.57812C9.4974 6.90365 9.66016 7.29427 9.66016 7.75V10.6992C9.66016 10.8164 9.64714 10.9401 9.62109 11.0703C9.59505 11.2005 9.54948 11.3242 9.48438 11.4414L8.35156 13.7266C8.2474 13.9349 8.09115 14.1042 7.88281 14.2344C7.6875 14.3516 7.46615 14.4102 7.21875 14.4102H6.75ZM13.4102 14.4102C13.3581 14.4102 13.2995 14.4036 13.2344 14.3906C13.1823 14.3776 13.1302 14.3581 13.0781 14.332C12.8828 14.2409 12.7526 14.0977 12.6875 13.9023C12.6224 13.694 12.6354 13.4922 12.7266 13.2969L13.8398 11.0898H13C12.5443 11.0898 12.1536 10.9271 11.8281 10.6016C11.5026 10.276 11.3398 9.87891 11.3398 9.41016V7.75C11.3398 7.29427 11.5026 6.90365 11.8281 6.57812C12.1536 6.2526 12.5443 6.08984 13 6.08984H14.6602C15.1289 6.08984 15.526 6.2526 15.8516 6.57812C16.1771 6.90365 16.3398 7.29427 16.3398 7.75V10.6992C16.3398 10.8164 16.3203 10.9401 16.2812 11.0703C16.2552 11.2005 16.2161 11.3242 16.1641 11.4414L15.0117 13.7266C14.9076 13.9349 14.7513 14.1042 14.543 14.2344C14.3477 14.3516 14.1328 14.4102 13.8984 14.4102H13.4102Z",
      fill: "currentColor"
    }
  )
);
const SvgFormatQuote = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var FormatQuote_default = SvgFormatQuote;
